import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import React from 'react';
import SortBy from './components/SortBy';
import uiLocale from '../../../utils/UILocale.js';
import { getListingPageSortBy } from '../../../appState/ducks/network';

const mappedSortOptions = {
  relevance_desc: 'none_descending',
  brand_asc: 'brand_ascending',
  brand_desc: 'brand_descending',
  price_asc: 'price_ascending',
  price_desc: 'price_descending',
  rating_desc: 'rating_descending',
  discount_desc: 'discount_descending'
};

export default function initSortBy() {
  const mountEl = document.querySelector('[data-component="list-page-sort-by"]');
  const title = uiLocale.getString('component.sortby.title');

  function mapStateToProps(state) {
    const options = state.listingPage.pageSetup.sortByOptions.optionsList;
    const selected = state.listingPage.pageSetup.sortByOptions.selectedOptionValue;
    const selectedId = options.findIndex((option) => option.value === selected);
    return {
      options: options.map((option) => ({
        id: (option.value).split('/')[0],
        label: option.translation
      })),
      defaultOptionIndex: selectedId
    };
  }

  const mapDispatchToProps = (dispatch) => ({
    onSelectedItemChange: (selectedOption) => {
      const optionId = (selectedOption.id).replace('-', '_');
      getListingPageSortBy(dispatch, mappedSortOptions[optionId]);
    }
  });

  const ConnectedSortBy = connect(mapStateToProps, mapDispatchToProps)(SortBy);

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedSortBy
          title={title}
        />
      </Provider>, mountEl
    );
  }
}
